import { axiosInstance } from '../config/axios';
import keycloak from '../keycloak';
import { convertGeojsonCRS, createGeojsonFromAreaMonitoringGeometry } from '../utils/areaMonitoring.utils';
import { parseScopeFromId } from '../utils/utils';

function formatField(field) {
  const geojson3857 = createGeojsonFromAreaMonitoringGeometry(field.geometry);
  const geojson4326 = convertGeojsonCRS(geojson3857);
  return {
    ...field,
    geometry: geojson4326,
  };
}

export default function api() {
  async function fetchFields(year, queryArguments, signal) {
    try {
      const query = `/refdata/${year}/fois/search?${queryArguments.join('&')}`;
      const response = await axiosInstance.get(query, { signal });
      return response.data.map((field) => formatField(field));
    } catch (e) {
      throw new Error(e);
    }
  }

  async function fetchNumberOfFields(year, filter, signal) {
    const query = `/refdata/${year}/fois/count?filter=${filter}`;
    return await axiosInstance.get(query, { signal });
  }

  async function fetchNeighbouringFields(fieldId, year, queryArguments, signal) {
    try {
      const response = await axiosInstance.get(
        `/refdata/${year}/fois/${fieldId}/neighbours?${queryArguments.join('&')}`,
        {
          signal,
        },
      );
      return response.data.map((field) => formatField(field));
    } catch (e) {
      throw new Error(e);
    }
  }

  async function fetchField(fieldId, signal) {
    try {
      const response = await axiosInstance.get(`/refdata/${parseScopeFromId(fieldId)}/fois/${fieldId}`, {
        signal,
      });
      return formatField(response.data);
    } catch (e) {
      throw new Error(e);
    }
  }

  async function fetchSoilTypes(year, signal) {
    return await axiosInstance.get(`/refdata/${year}/codes/soil-types`, { signal });
  }

  async function fetchCropTypes(year, signal) {
    return await axiosInstance.get(`/refdata/${year}/codes/crops`, { signal });
  }

  async function fetchSignals(foi, time, types, signal) {
    try {
      const scope = parseScopeFromId(foi);
      const query = `/signal/${scope}/signals`;
      const response = await axiosInstance.get(query, {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
        },
        params: { foi, time, types, stats: 'value,mean' },
        signal,
      });
      return response;
    } catch (e) {
      throw new Error(e);
    }
  }

  return {
    fetchFields,
    fetchNumberOfFields,
    fetchNeighbouringFields,
    fetchField,
    fetchSoilTypes,
    fetchCropTypes,
    fetchSignals,
  };
}
